import { asCurrency, asPercentage, getInflationDecrease, updateValuesFromFields, validateFields } from '../util'
import { useAppState } from '../Context'
import { InflationChart } from '../components/Charts'
import { InflationScheduleTable } from '../components/Tables'
import { InputFields } from '../components/Fields'
import CalculateResults from '../components/CalculateResults'
import CalculateRow from '../components/CalculateRow'

function PanelInput() {
  return <InputFields />
}

function PanelCalculate() {
  const { values } = useAppState()

  return (
    <CalculateResults>
      <CalculateRow>
        <div className="richtext wysiwyg">
          <p>This calculator shows the projected decrease in value of a dollar due to the effects of inflation.</p>
          <p className="font-bold">
            Based on an inflation rate of {asPercentage(values.inflationRate)} the value of{' '}
            {asCurrency(values.currentValue)} is going to be reduced to {asCurrency(values.inflation.newValue)} in{' '}
            {values.numYears} years.
          </p>
          <p>
            The Chart shows the year-by-year decrease in value, based on the factors in the input. Even low rates of
            inflation can have dramatic effects on the value of a dollar.For example, assuming a 4% rate of inflation,
            the value of a dollar will be cut in half in 18 years.
            <br />
            The Detail page shows the year-by-year decrease amount along with the value by year, based on the inputs.
          </p>
        </div>
      </CalculateRow>
    </CalculateResults>
  )
}

function PanelChart() {
  const { values } = useAppState()

  return (
    <div className="py-4 space-y-4">
      <InflationChart inflation={values.inflation} title="Future Value of a Dollar" />
    </div>
  )
}

function PanelDetail() {
  const { values } = useAppState()

  return <InflationScheduleTable inflation={values.inflation} type="decrease" />
}

export default {
  name: 'What is the future value of a dollar?',
  tabs: [
    {
      name: 'Input',
      component: PanelInput,
      beforeTabChange: (dispatch, fields, values) => {
        const validate = validateFields(fields)

        if (validate.isValid) {
          const updatedValues = updateValuesFromFields(values, fields)
          const inflation = getInflationDecrease(
            updatedValues.currentValue,
            updatedValues.numYears,
            updatedValues.inflationRate
          )

          dispatch({ type: 'setValues', payload: { ...updatedValues } })
          dispatch({ type: 'setValue', payload: { name: 'inflation', value: inflation } })
        }

        dispatch({ type: 'setFields', payload: validate.fields })

        return validate.isValid
      },
    },
    {
      name: 'Calculate',
      component: PanelCalculate,
    },
    {
      name: 'Chart',
      component: PanelChart,
    },
    {
      name: 'Detail',
      component: PanelDetail,
    },
  ],
  fields: [
    {
      type: 'number',
      dataType: 'float',
      displayAs: 'currency',
      name: 'currentValue',
      label: 'Current Value of Item',
      value: 1000,
    },
    {
      type: 'number',
      dataType: 'int',
      name: 'numYears',
      label: 'Number of Years',
      value: 20,
    },
    {
      type: 'number',
      dataType: 'float',
      displayAs: 'percent',
      name: 'inflationRate',
      label: 'Annual Inflation Rate',
      value: 3,
    },
  ],
}
